<!--
 * @Description: 
 * @Author: 王佳兴
 * @Github: 
 * @Date: 2019-01-15 19:30:58
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-07-27 16:55:36
 -->
<template>
  <div class="box vux-1px-b" ref="signBox">
    <p v-if="num">
      <img
        class="play_img"
        src="https://cdn.yxvzb.com/newWechat/image/%E6%92%AD%E6%94%BE%E6%AC%A1%E6%95%B0@2x.png"
        alt=""
      />
      <span>{{ num }}次</span>
    </p>
    <div class="course_info" @click="showMore" v-show="detailObj.wxSummary">
      <!-- <div v-show="!show" class="abstract">{{detailObj.courseAbstract}}</div> -->
      <p style="margin-bottom:.3rem;color:#333;font-size:.35rem;">
        课程介绍：
        <!-- <i :class="['icon','iconfont',show?'icon-packup':'icon-unfold']"></i> -->
      </p>
      <div v-html="detailObj.wxSummary"></div>
    </div>
    <!-- <p @click="signIn" class="signIn">
      <img src="https://cdn.yxvzb.com/newWechat/image/%E7%AD%BE%E5%88%B0@2x.png" alt="">
      <span>{{isSignIn ? '已签到' : '签到'}}</span>
    </p> -->
    <!-- <div v-if="isLiving&&status=='living'" id="giftCount" class="" ref="flowerBox">
      <img src="//cdn.yxvzb.com/img/flower/flower.png">
      <span>×<b id="realCount">{{flowerCount}}</b></span>
    </div> -->
  </div>
</template>
<script>
import { signIn } from '@/api/ajax.js';
import { mapState, mapActions } from 'vuex';
export default {
  name: '',
  props: {
    isSignIn: {
      type: Number,
      default: 0
    },
    num: {
      default: ''
    },
    isLiving: {
      default: false
    },
    status: {
      default: ''
    },
    detailObj: {
      default: {}
    }
  },
  data() {
    return {
      noQue: false,
      restTime: 0,
      timer1: null, //定时器编号
      // TODO 假數據
      courseInfo: {
        title: 'STEMI患者規範化二級預防第二節',
        content:
          '雙向情感障礙 （又稱鐘擺病），屬於心境障礙的一種，嚴重了，可能會為及生命，為了家人們的健康，所以我們如果有需要，要相信科學，盡早就醫才是最正確的做法。'
      },
      show: false
    };
  },
  methods: {
    showMore() {
      this.show = !this.show;
    },
    plus(item) {
      this.flowerCount = item.count;
    },
    signIn() {
      let data = {
        courseId: this.$route.params.id
      };
      if (this.isSignIn) {
        this.$vux.toast.show({
          type: 'text',
          text: '您已签到',
          position: 'middle'
        });
      } else if (this.noQue) {
        this.$vux.toast.show({
          type: 'text',
          text: '当前课程还没有考题',
          position: 'middle',
          width: '6rem'
        });
      } else {
        if (this.restTime >= 60) {
          this.$router.push({
            name: 'signIn',
            params: {
              id: this.$route.params.id
            },
            query: {
              isLiving: this.isLiving
            }
          });
        } else {
          this.$vux.toast.show({
            type: 'text',
            text: '听课满一分钟才能签到',
            position: 'middle',
            width: '6rem'
          });
        }
      }
    }
  },
  created() {
    let that = this;
    this.timer1 = setInterval(function() {
      if (that.restTime >= 60) {
        clearInterval(that.timer1);
      } else {
        that.restTime = that.restTime + 1;
      }
    }, 1000);
    let data = {
      courseId: that.$route.params.id
    };
    signIn
      .questions(data)
      .then(res => {
        if (!res.data.data || !res.data.data.length) {
          that.noQue = true;
        }
      })
      .catch(e => {
        that.noQue = true;
      });
  },
  beforeDestroy() {
    clearInterval(this.timer1);
  },
  computed: {
    ...mapState({
      flowerCount: state => state.flowerCount
    })
  },
  components: {},
  mounted() {}
};
</script>
<style lang="less" scoped>
.abstract {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 7rem;
}
#giftCount {
  position: absolute;
  left: 0.4rem;
  z-index: 10;
  top: -0.3rem;
}
#giftCount span {
  background-image: linear-gradient(-180deg, #41d5fd 0%, #1a92fc 97%);
  font-size: 1rem;
  font-weight: bold;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  line-height: 1rem;
}
#giftCount img {
  width: 1.128rem;
  height: 1.128rem;
  line-height: 1rem;
  vertical-align: top;
}
.box {
  display: flex;
  /*border-bottom: 1px solid #EBEBEB;*/
  padding-bottom: 0.39rem;
  position: relative;
}
// 新的課程信息
.course_info {
  font-size: 0.32rem;
  color: #999999;
  margin-top: 0.3rem;
  p {
    margin-top: 0.21rem;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 7rem;
    overflow: hidden;
  }
  .is_show_more {
    position: absolute;
    top: -0.22rem;
    right: -0.2rem;
    width: 1.33rem;
  }
}
.courseInfo_content {
  margin-top: 0.8rem;
}
.play_img {
  width: 0.24rem;
  height: 0.3466rem;
}
span {
  font-size: 0.24rem;
  color: #999;
}
p {
  span {
    color: #000;
  }
  img {
    width: 0.5rem;
    height: 0.5rem;
  }
}
.signIn {
  position: absolute;
  right: 0;
  top: -1.5rem;
}
</style>
